import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

interface SummaryFooterProps {
  setEditIndex: (index: number) => void
}

const SummaryFooter: React.FC<SummaryFooterProps> = ({ setEditIndex }) => {
  const dispatch = useDispatch()
  const formData = useSelector((state: any) => state.formData)
  const appData = useSelector((state: any) => state.appData)
  const layout = useSelector((state: any) => state.layout)
  
  const { phoneItems, family } = formData
  const { subscriptions } = appData

  const editItem = (index: number) => {
    console.log('edit item')
    setEditIndex(index)
  }

  // Only for single, regular subs for now
  if (!(phoneItems && phoneItems.length)) {
    return null
  }

  return (
    <div className="summary-footer">
      {Boolean(phoneItems.length) && (
        <div>
          {phoneItems.map((item: any, i: number) => {
            const isOwner = i === 0 && !formData.singleExistingOwnerPhoneNo
            const sub = subscriptions.find((s: any) => s.id === item.subscriptionId)
            const bDate = item.dateOfBirth
            return (
              <div
                key={`item-${i}`}
                className={`item ${i === 0 ? 'owner-item' : ''}`}
                onClick={() => editItem(i)}
              >
                <div className="info">
                  <div className="subscriber">
                    {item.firstName} {item.lastName} (f. {bDate})
                  </div>
                  <div className="email">
                    {item.email}
                    {item.email && item.phone ? ' · ' : ''}
                    {item.phone}
                  </div>
                  <div className="phone"></div>
                  <div className="subscription">{sub.name}</div>
                </div>
                <div className="controls">
                  <button className="icon edit-item"></button>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default SummaryFooter